import { Injectable } from '@angular/core';
import { URL_BASE } from '../../core/constants';
import { Observable } from 'rxjs';
import { HttpUtils } from '../../shared/http-utils';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class OverviewService {

  private URI = 'api';

  constructor(private http: HttpClient) {
  }

  public getOverview(): Observable<any> {
    const headers = HttpUtils.createHeaders();
    const url     = `${URL_BASE}/${this.URI}/overview`;
    return this.http.get(url, { headers });
  }

}
